import { render } from "./FinanceSection.vue?vue&type=template&id=6e000887"
import script from "./FinanceSection.vue?vue&type=script&lang=js"
export * from "./FinanceSection.vue?vue&type=script&lang=js"
script.render = render

export default script